import { Suspense } from 'react'
import Preloader from '@/components/Preloader'
import type { ChildrenType } from '@/types/component'
import Header from '@/components/layout/Header'
import Footer from '@/components/vietrro/Footer'
import { useLocation } from 'react-router-dom'
import clsx from 'clsx'

const OtherLayout = ({ children }: ChildrenType) => {
  const { pathname } = useLocation();
  const withFullLayout = 
    pathname.startsWith('/home')
    || pathname.startsWith('/users/')
    || pathname.startsWith('/marketplace');

  return (
    <Suspense fallback={<Preloader />}>
      <Header />
      <div className={clsx(
        'mx-auto',
        withFullLayout ? "mt-[56px]" : "max-w-7xl mx-auto mt-[80px]",
      )}>
        {children}
      </div>
      <Footer />
    </Suspense>
  )
}

export default OtherLayout
